import { render, staticRenderFns } from "./floordownload.vue?vue&type=template&id=b6267ef6&scoped=true&"
import script from "./floordownload.vue?vue&type=script&lang=js&"
export * from "./floordownload.vue?vue&type=script&lang=js&"
import style0 from "./floordownload.vue?vue&type=style&index=0&id=b6267ef6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6267ef6",
  null
  
)

export default component.exports